import React from 'react';
import {
  Platform,
  View,
  StyleSheet,
  Text,
  ScrollView,
} from 'react-native';
import { UserDataConsumer } from 'fitbeat.react-native-components';
import TrackingWorkoutStandardStats from './components/tracking-workout-standard-tile-text';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { Dropdown, toggleScanReportModalVisible } from '../ui';
import { Field, reduxForm } from 'redux-form';
import { getScanStats, loadInitialStateAndLatestScan } from './actions';
import { UserServiceClient } from 'fitbeat.api-clients';
import { getApiConfig } from '../config';
import { AuthTokenBuilder } from '../utils/authTokenBuilder';
import { GoogleAnalytics } from '../services/google-analytics';
import { TrackingLoadingTile } from './components/tracking-loading-tile';
import { BodyScanReport } from '../Stats/components/BodyScanReport';
import moment from 'moment-timezone';
import TrackingGaugeLegend from './components/tracking-gauge-legend';
import { defaultScale, fullWidthMinusPadding } from '../utils/scaling';
import Theme from '../theme';
import { trackingScanStatsSelector } from './selectors';

const isWeb = Platform.OS === 'web';
const CONTAINER_PADDING = 10;

class TrackingScanStatsTile extends React.Component {
  onFocusListener;

  constructor(props) {
    super(props);
    this.state = {
      pdf: null,
      isLoadingPdf: false,
      pdfError: null,
      myScans: [],
      scanIndex: 0,
      sections: [],
      dateOfScanOptions: [],
    };

    this.props.loadInitialStateAndLatestScan();
  }

  navigationDidFocus = () => {
    this.props.loadInitialStateAndLatestScan();
  }

  componentWillUnmount = () => {
    this.onFocusListener.remove();
  }

  componentDidMount = () => {
    this.onFocusListener = this.props.navigation.addListener('didFocus', () => this.navigationDidFocus());
  }

  downloadReport = async () => {
    try {
      if (Platform.OS !== 'web') {
        this.openScanReportModal();
      }
      const myScans = await this.props.user.userProfileService.getMyBodyScans();
      if (myScans) {
        const scanIndex = myScans.findIndex(({ dateOfScanDateOnly }) =>
        moment(dateOfScanDateOnly).format('YYYY-MM-DD') === moment(this.props.lastScanDate).format('YYYY-MM-DD'));
        this.setState({ isLoadingPdf: true, pdfError: null });
        const report = await this.props.user.userProfileService.getBodyScanPdf(myScans[scanIndex].id);
        await this.setState({ pdf: report.attachment });
      }
    } catch (error) {
      this.setState({ pdfError: error });
    } finally {
      this.setState({ isLoadingPdf: false });
    }
  }

  openScanReportModal = () => {
    this.props.toggleScanReportModalVisible(true);
  }

  closeScanReportModal = () => {
    this.props.toggleScanReportModalVisible(false);
  }

  render() {
    const { t, user: { userProfile } } = this.props;
    const userHasHRM = (userProfile.heartRateMonitorIdentifier || userProfile.heartRateMonitorIdentifier !== '');
    return (
      <View style={style.mainContainer}>
        <View style={style.paddingContainer}>
          <ScrollView >
            {this.props.scanStatDates && this.props.scanStatDates.length > 0 &&
              <View style={style.dropdownContainer}>
                <Field
                  webAbsolute
                  isRequired={false}
                  name='dateOfScan'
                  showLabel={false}
                  valueKey='value'
                  displayKey='displayName'
                  defaultIndex={0}
                  options={this.props.scanStatDates}
                  component={Dropdown}
                  rowWidth={fullWidthMinusPadding(CONTAINER_PADDING * 2)}
                  onSelect={this.props.getScanStats}
                  hideIndicatorSeparator={true}
                  mainDropdownContainerStyle={{ borderRadius: 0 }}
                  controlStyle={{backgroundColor: Theme.WHITE}}
                />
              </View>}
            <View style={style.mealTitleContainer}>
              <Text style={style.mealTitle}>{t('scanStats')}</Text>
              <Text style={style.mealTitleDetail}>{this.props.lastScanDate && `${this.props.lastScanDate.toUpperCase()}`}</Text>
            </View>
            {this.props.isLoading === true ?
              <TrackingLoadingTile isLoading={this.props.isLoading} /> :
              this.props.scanStats ?
                <TrackingWorkoutStandardStats standardStats={this.props.scanStats} type={'scanStats'} /> :
                <View style={style.noDataContainer}>
                  <Text style={style.noDataText}>You haven’t done a scan this month</Text>
                </View>
            }
            <BodyScanReport
              t={t}
              pdf={this.state.pdf}
              scanDate={moment(this.props.lastScanDate).format('D MMMM YYYY   |   HH:mm')}
              closeModal={this.closeScanReportModal}
              isModalVisible={this.props.isScanReportModalVisible}
              error={this.state.pdfError}
              isLoading={this.state.isLoadingPdf}
            />

          </ScrollView>
        </View>
        {userHasHRM && !this.props.isLoading && !isWeb &&
        <View style={{marginTop: -10}}>
          <TrackingGaugeLegend />
        </View>}

      </View>
    );
  }
}

const style = StyleSheet.create({
  mainContainer: {
    backgroundColor: Theme.GREY_LIGHT,
    height: '100%',
  },
  paddingContainer: {
    padding: defaultScale(CONTAINER_PADDING),
    paddingTop: 0,
    flex: 1,
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 8,
    borderColor: '#575656',
    borderWidth: 1,
    ...Platform.select({
      web: {
        paddingVertical: 0,
      },
    }),
  },
  buttonContainer: {
    width: '100%',
    paddingTop: defaultScale(8),
    marginBottom: defaultScale(20),
  },
  mealTitleContainer: {
    padding: defaultScale(8),
    flexDirection: 'row',
    width: '100%',
    justifyContent: 'space-between',
  },
  mealOfDay: {
    ...Theme.textStyle.heading,
    color: Theme.WHITE,
  },
  mealTitle: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.GREY_DARK,
    paddingLeft: defaultScale(4),
    alignSelf: 'flex-start',
  },
  mealTitleDetail: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.GREY_DARK,
    paddingLeft: defaultScale(4),
    alignSelf: 'flex-end',
  },
  mealDetailsContainer: {
    flexDirection: 'row',
    width: '100%',
  },
  noDataContainer: {
    padding: defaultScale(20),
    alignItems: 'center',
  },
  noDataText: {
    ...Theme.textStyle.bodyCopyReg,
    color: Theme.GREY_DARK,
    letterSpacing: 0,
    marginTop: defaultScale(10),
    marginBottom: defaultScale(10),
  },
  dropdownContainer: {
    zIndex: 1,
    paddingTop: defaultScale(10),
  },
});

const mapStateToProps = (state) => {
  const { isLoading, error, monthAndYearRange, selectedMonthAndYear, workoutHeaderDateRange, lastScanDate, scanStatDates, selectedScanStatDate } = state.tracking.view;
  const { stats, workoutStats } = state.tracking.data;
  return {
    error,
    isLoading,
    monthAndYearRange,
    selectedMonthAndYear,
    workoutHeaderDateRange,
    statistics: stats,
    workoutStats,
    scanStats: trackingScanStatsSelector(state),
    lastScanDate,
    scanStatDates,
    selectedScanStatDate,
    isScanReportModalVisible: state.ui.scanReportModalVisible,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  const userServiceClient = new UserServiceClient(getApiConfig(), fetch, console.log, new AuthTokenBuilder(), GoogleAnalytics);
  return {
    loadInitialStateAndLatestScan: () => dispatch(loadInitialStateAndLatestScan(userServiceClient, new Date())),
    getScanStats: (date) => {
      dispatch(getScanStats(userServiceClient, new Date(), date));
    },
    toggleScanReportModalVisible: (visible) => dispatch(toggleScanReportModalVisible(visible)),
  };
};

TrackingScanStatsTile = UserDataConsumer(connect(mapStateToProps, mapDispatchToProps)(TrackingScanStatsTile));
TrackingScanStatsTile = reduxForm({ form: 'StatsForm' })(TrackingScanStatsTile);
export default translate(['workoutHistory'])(TrackingScanStatsTile);
